export enum RbcActivityEntryRawEventName {
  ActivityEntry = "ActivityEntry",
}

export type ActivityEntryProperties = {
  advance?: number;
  departure_date?: string;
  return_date?: string;
  destination?: string;
  destination_label?: string;
  destination_country_code?: string;
  destination_country_grouping?: string;
  destination_region_code?: string;
  is_agent_session?: boolean;
};

export interface ActivityEntryRawEvent {
  name: RbcActivityEntryRawEventName.ActivityEntry;
  properties: ActivityEntryProperties;
}
